import React, { Component } from 'react';
import PageHeader from '../reports/PageHeader';
import RadarChart from '../charts/radarchart';
import DottedLines from '../reports/DottedLines';
import RadarCaptionKeys from './RadarCaptionKeys';
import TitlePage from '../reports/TitlePage';

export default class RelationshipCompetencyComparison extends Component {
  constructor(props) {
    super(props);

    this.addTableRowHeight = this.addTableRowHeight.bind(this);
    this.addCaptionRowHeights = this.addCaptionRowHeights.bind(this);

    this.state = { 
      ...this.props.state,
      limits: [{lowerLimit: 0, upperLimit: this.props.orderedSectionIDs.length}],
      limitsUpdated: 0,
      pdfReCalculationsComplete: false,
    };
  }

  componentDidMount() {
    const captionKeysCount = this.props.captionKeysList.length;
    if (captionKeysCount === 0) {
      this.props.updateCompetencyComparisonPDFExportPreRenderStatus();
    }
    this.setState({captionKeysCount});
  }

  addTableRowHeight(tableRowHeight) {
    this.setState({tableRowHeight})
  }

  addCaptionRowHeights(captionRowHeights) {
    this.setState({captionRowHeights})
  }

  render() {
    const { reportType, generateGraph, reviewerAnswers, completedRelationshipIDs, current360Relationships, chartOptions, captionsLoaded, data, captionKeysList, convertSVGToImage, orderedSectionIDs, sectionDetails, pdfRequested, updateCompetencyComparisonPDFExportPreRenderStatus, layoutMode } = this.props;
    const { captionKeysCount } = this.state;

    const { limits, limitsUpdated } = this.state;

    const captionsColumnsCount = limits.length;

    return generateGraph && (
      <>
        <TitlePage h1Text='Part 1:' h2Text={`${reportType === 'Team' ? 'Team' : 'Your'} Feedback Summary`} />
        <div className='bg-white user-report__content'>
          <PageHeader
            containerClass='page-break'
            h2Class='mt4'
            h2Text='Part 1: '
            strong='Step 1'
            h3Text={`Competencies: ${
              reportType !== 'Self' ? 'comparison by reviewer group' : 'an overview of your competencies'
            }`}
            line={true}
          />
          <p>
            The competency chart gives you a summary picture of how {reportType === 'Group' ? 'the group perceive their' : 'you perceive your'} general
            strengths and development needs
            {reportType !== 'Self' && `, compared with ${reportType === 'Group' ? 'the' : 'your'} reviewers' perceptions`}.
          </p>
          <p>
            {reportType === 'Self' && 'Delivering highly-rated competencies indicates your strengths.'}
            {reportType === 'Group' &&
              'Competencies where each rater group has provided similar feedback ratings indicates that the group delivers that competency consistently. Critically, delivering highly rated competencies consistently, indicates a strength for the group.'}
            {reportType !== 'Self' &&
              reportType !== 'Group' &&
              'The areas where you have competencies with similar feedback ratings, from each rater group, shows that you deliver that competency consistently. Delivering consistently highly-rated competencies indicates your strengths.'}
          </p>
          <p>
            Conversely, delivering consistently lowly-rated competencies can point to areas where {reportType === 'Group' ? 'the group' : 'you'} may need to
            change/improve.
          </p>
          <p>
            {reportType !== 'Self'
              ? `Areas where you might notice significant ‘gaps’ between the ratings provided by rater groups (e.g., line manager compared to direct reports), suggests a mismatch between their experiences in working with ${
                  reportType === 'Group' ? 'the group' : 'you'
                }, or different perceptions. These gaps can be explored in more detail i`
              : 'I'}
            n the ’Your detailed feedback’ section of the report
            {reportType === 'Self' && ", you'll be able to explore your capabilites in more detail"}.
          </p>

          {captionKeysCount > 0 && (
                <RadarCaptionKeys 
                  orderedSectionIDs={orderedSectionIDs} 
                  captionsLoaded={captionsLoaded} 
                  captionKeysList={captionKeysList}
                  sectionDetails={sectionDetails}
                  captionKeysCount={captionKeysCount}
                  pdfRequested={pdfRequested}
                  updateCompetencyComparisonPDFExportPreRenderStatus={updateCompetencyComparisonPDFExportPreRenderStatus}
                  layoutMode={layoutMode}
                />
          )}
          
          <div className='page-break'>
            {/* <div className='flex w-100 chartTable mt4'> */}
            <div className='flex w-100 chartTable'>
              <div className='w-50'>
              {/* <div className='w-50 mv4'> */}
                {reportType !== 'Team' && (
                  // <p className='mv0'>
                  <p>
                    <span className='w1 h1 dib br-100 bg-blue v-mid mr2'></span> <strong>Self</strong>
                  </p>
                )}
                {completedRelationshipIDs ? (
                  completedRelationshipIDs.map((relationshipID, index) => {
                    return (
                      <p key={relationshipID}>
                        <span className='w1 h1 dib br-100 v-mid mr2' style={{ background: current360Relationships[relationshipID]['colour'] }}></span>
                        <strong> {current360Relationships[relationshipID]['name']}</strong>
                        <br />
                      </p>
                    )
                  })
                ) : (
                  reviewerAnswers && (
                    Object.keys(reviewerAnswers).map((relationshipID, index) => {
                      if (Object.keys(reviewerAnswers[relationshipID]).length) {
                        return (
                          <p key={relationshipID}>
                            <span className='w1 h1 dib br-100 v-mid mr2' style={{ background: current360Relationships[relationshipID]['colour'] }}></span>
                            <strong>{current360Relationships[relationshipID]['name']}</strong>
                            <br />
                          </p>
                        )
                      } else {
                        return '';
                      }
                    })
                  )
                )}
              </div>
              <div className='w-50'>
                <p className='tr'>
                  <strong>Outer ring on graph</strong> = greater frequency of behaviours
                  <br />
                  <strong>Inner ring</strong> = lower frequency of behaviours
                </p>
              </div>
            </div>
          </div>
          <div className='radar'>
            {
              <img
                style={{ margin: 'auto' }}
                src={convertSVGToImage(<RadarChart captions={captionsLoaded} data={data} size={chartOptions.size} options={chartOptions} />)}
                alt='Radar chart showing competency ratings'
              />
            }
          </div>
          {reportType !== 'Group' && (
            <div className='page-break mv4'>
              <h3 className='f5 gray '>Reflection</h3>
              <p>What initial impressions do you have from this graph about your possible strengths or areas for development?</p>
              <DottedLines numberOfLines={26} />
            </div>
          )}
        </div>
      </>
      
    )
  }
}